<template>
  <div>
    <div style="display: flex;width:300px;margin-bottom : 10px" v-if="false">
      <div style="width:160px" class="row-tb-head"> 表格最大高度：</div>
      <el-input v-model.number="tableHeight" type="number" placeholder="请输入表格高度" @change="updateTableHeight"></el-input>
    </div>
    <!-- 模具信息 -->
    <div class="row-tb-head" style="margin-top: 10px"><span>模具信息</span></div>
    <el-table ref="table" :data="modelData" @row-click="onRowClick" :max-height="tableHeight" class="table_bottom table-line tb-c-head" border>
      <el-table-column prop="MouldNo" label="模具编码" min-width="130" align="center"></el-table-column>
      <el-table-column prop="MouldName" label="模具名称" min-width="160" align="center"> </el-table-column>
      <el-table-column prop="PerGrossWeight" label="每模毛重" min-width="80" align="center"></el-table-column>
      <el-table-column prop="PerNetWeight" label="每模净重" min-width="80" align="center"></el-table-column>
      <el-table-column prop="Afew" label="1出几套" min-width="80" align="center"></el-table-column>
      <el-table-column prop="Quantity" label="需求模数" min-width="100" align="center"></el-table-column>
      <!-- <el-table-column prop="ImgUrl" label="图片" min-width="110" align="center" >
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row.ImgUrl)">查看</el-button>
        </template>
      </el-table-column> -->
      <el-table-column prop="Remarks" label="备注" min-width="130" align="center">
      </el-table-column>
      <el-table-column prop="Bomno" label="BOM版本号" min-width="200" align="center">
      </el-table-column>
    </el-table>

    <!-- 胶件信息 -->
    <div class="row-tb-head" style="margin-top: 10px"><span>胶件信息</span></div>
    <el-table ref="glueTable" :data="tableData_filter" class="table_bottom table-line tb-c-head"  border>
      <el-table-column prop="ProductNo" label="胶件编码" min-width="160" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.ProductNo }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ProductName" label="胶件名称" min-width="160" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.ProductName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="BarCode" label="存货条码" min-width="160" align="center">
     
      </el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="110" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.PropertyName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="160" align="center">
     
      </el-table-column>
      <el-table-column prop="Quantity" label="需求数量" min-width="80" align="center">
      </el-table-column>
      <el-table-column prop="ImgUrl" label="图片" min-width="80" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="Remarks" label="备注" min-width="110" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.Remarks }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- <div class="row-tb-head" style="margin-top: 10px"><span>工艺</span></div>
    <el-table :data="ProcessData" class="table_bottom table-line tb-c-head" border ref="list3">
      <el-table-column prop="MouldName" label="模具名称" min-width="120"></el-table-column>
      <el-table-column prop="MouldNo" label="模具编码" min-width="120"></el-table-column>
      <el-table-column prop="ProgrammeName" label="工艺方案名称" min-width="120">
      </el-table-column>
      <el-table-column label="方案详情" min-width="120">
        <template slot-scope="{ row }">
          <el-button type="text" @click="changeProgrammeInfo(row)">详情编辑</el-button>
        </template>
      </el-table-column>
    </el-table> -->

    <!-- 子件信息 -->
    <div v-for="(item, index) in detailData_filter" :key="index">
      <div class="row-tb-head" style="margin-top: 10px">
        <span>{{ item.name }}</span>
      </div>
      <el-table ref="sub_table" class="table_bottom table-line tb-c-head" :data="item.DetailModels" border>
        <el-table-column prop="ProductNo" label="子件编码" min-width="110" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ProductNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ProductName" label="子件名称" min-width="110" align="center">
        </el-table-column>
        <el-table-column prop="ProductSpec" label="规格" min-width="110" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ProductSpec }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="UnitName" label="单位" min-width="126" align="center">
        </el-table-column>
        <!-- <el-table-column prop="ColorName" label="颜色" min-width="110" align="center">
        </el-table-column> -->
        <el-table-column prop="NeedQuantity" label="需求数量" min-width="120" align="center">
        </el-table-column>
        <el-table-column prop="ImgUrl" label="图片" min-width="110" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }}</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="ProcessStage" label="加工阶段" min-width="110" align="center">
          <template slot-scope="{ row }">
            <span>{{ (() => {

              if (row.ProcessStage === 3) {
                return '装配'
              } else if (row.ProcessStage === 1) {
                return '注塑'
              } else if (row.ProcessStage === 2) {
                return '配件'
              } else if (row.ProcessStage === 0) {
                return '无'
              } else if (row.ProcessStage === 4) {
                return '组装'
              }else if(row.ProcessStage===1024){
                return '胶件加工'
              }else if(row.ProcessStage===1026){
                return '印刷'
              }else if(row.ProcessStage===1027){
                return '喷涂'
              }

            })() }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="ProduceTypeName" label="存货类型" min-width="110" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.ProduceTypeName }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="库存数量" min-width="110" align="center></el-table-column>
        <el-table-column label="领用数量" min-width="110" align="center"></el-table-column>
        <el-table-column label="耗用数量" min-width="110" align="center"></el-table-column> -->
      </el-table>
    </div>

    <come-list-dialog @select="comeSelect" ref="comeListDialog" in-dialog />
    <img-dialog ref="imgDialog" :imgs="imgs" />
    <list-dialog ref="listDialog" selectable :multiple="false" @select="listDialogSelect"></list-dialog>
    <detail-dialog ref="detailDialog" @saved="detail_saved"></detail-dialog>
  </div>
</template>

<script>
import bomDialog from "./bomDialog";
import accountSelect from "@/components/production/clothmanagement/cloth/select";
import comeListDialog from "@/components/basedata/business/come/listDialog";
import imgDialog from "./imgDialog";
import listDialog from "@/components/production/craftsmanship/solutions/mold/listDialog";
import detailDialog from "./detailDialog";
import { urlHttp } from './bomConfig'


export default {
  name: "wjGlue",
  components: {
    bomDialog,
    accountSelect,
    comeListDialog,
    imgDialog,
    listDialog,
    detailDialog,
  },
  props: {
    glueTable: {
      type: Array,
      default: () => [],
    },
    flag: {
      type: Boolean,
      default: false,
    },
    productData: {
      type: Array,
      default: () => []
    },
    processListProp: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    glueTable(data) {
      console.log('glueTable data', data)

      this.tableData = data;

    },

  },
  data() {
    return {
      tableData: [],
      tableData_filter: [],
      ProcessData: [],
      detailData: [],
      detailData_filter:[],
      pdApi: require("@/api/ba/product").default,
      mouldApi: require("@/api/ba/mould").default,
      teProcessApi: require("@/api/production/teProcess").default,
      teMouldBomApi: require('@/api/production/teMouldBom').default,
      processList: [],
      mouldList: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      tableData: [],
      modelData: [],
      subTableData: [],
      tempItem: {},
      currentRow: null,
      imgs: [],
      craftData: [],
      delTable: [],
      delCraftData: [],
      columns: [
        {
          key: "MouldNo",
          prop: "MouldNo",
          lable: "模具编码",
        },
        {
          key: "MouldName",
          prop: "MouldName",
          lable: "模具名称",
        },
        {
          key: "PerGrossWeight",
          prop: "PerGrossWeight",
          lable: "每模毛重",
        },
        {
          key: "PerNetWeight",
          prop: "PerNetWeight",
          lable: "每模净重",
        },
        {
          key: "Afew",
          prop: "Afew",
          lable: "1出几套",
        },
        {
          key: "ImgUrl",
          prop: "ImgUrl",
          lable: "图片",
        },
        {
          key: "Remarks",
          prop: "Remarks",
          lable: "备注",
        },
        {
          key: "Bomno",
          prop: "Bomno",
          lable: "Bom版本",
        },
      ],
      innerColumns: [
        {
          key: "ProductNo",
          prop: "ProductNo",
          lable: "子件编码",
        },
        {
          key: "ProductName",
          prop: "ProductName",
          lable: "子件名称",
        },
        {
          key: "ProductSpec",
          prop: "ProductSpec",
          lable: "规格",
        },
        {
          key: "PdUnitName",
          prop: "PdUnitName",
          lable: "单位",
        },
        {
          key: "ColorName",
          prop: "ColorName",
          lable: "加工前颜色",
        },
        {
          key: "ImgUrl",
          prop: "ImgUrl",
          lable: "图片",
        },
        {
          key: "ProcessStage",
          prop: "ProcessStage",
          lable: "加工阶段",
        },
        {
          key: "ProduceTypeName",
          prop: "ProduceTypeName",
          lable: "存货类型",
        },
      ],
      tableHeight:600,
    };
  },
  created() {
    // this.pdApi.list({ Status: 1 }).then((res) => {
    //   let data = res.Data.filter((item) => {
    //     return item.ProcessStage === 0;
    //   });
    //   this.DAccount = data;
    //   this.initDAccount = data;
    //   this.listTotal = data.length;
    //   this.initTotal = data.length;
    // });


    let mouldList = JSON.parse(localStorage.getItem('mouldList'));
    this.mouldList = mouldList;

    // this.mouldApi.list({ Status: 1 }).then((res) => {
    //   if (res.Code === 0) {
    //     this.mouldList = res.Data;
    //   }
    // });

    // this.teProcessApi.list({}).then((res) => {
    //   if (res.Code === 0) {
    //     this.processList = res.Data;
    //   }
    // });
  },
  methods: {
    delProcess(index, o) {
      let row = this.craftData[index];
      if (row) {
        row.T = 2;
        this.delCraftData.push(row);
        if (o) {
          this.craftData.splice(index, 1, o);
        } else {
          this.craftData.splice(index, 1);
        }
      }

    },
    changeProgramme(row) {
      this.currentRow = row;
      this.$refs.listDialog.open();
    },
    changeProgrammeInfo(row) {
      this.currentRow = row;
      this.$refs.detailDialog.open().then((that) => {
        that.setTableData(row);
      });
    },
    onRowClick(row) {
      this.detailData_filter = this.detailData.filter((item) => item.name == row.MouldName);
      this.tableData_filter = this.tableData.filter((item) => item.MouldId == row.MouldId);
    },
    // 当输入框的值改变时，更新表格的高度
    updateTableHeight() {
      this.$nextTick(() => {
        this.$refs.table.bodyWrapper.style.height = `${this.tableHeight}px`;
      });
    },
    listDialogSelect(list) {
      this.currentRow.ProgrammeName = list.ProgrammeName;
      this.currentRow.Processes = list.Processes;
      this.currentRow.ProgrammeId = list.ProgrammeId;
    },
    detail_saved(list) {
      this.currentRow.Processes = list;
    },
    selectCome(row) {
      this.currentRow = row;
      this.$refs.comeListDialog.open();
    },
    comeSelect(row) {
      this.currentRow.TradeUnitId = row.TradeUnitId;
      this.currentRow.FullName = row.FullName;
    },
    setTableData(list) {
      this.modelData = list;

      console.log('=======this.modelData========', this.modelData)
      let ids = this.modelData.map(item => {
        return item.TemouldBomId;
      })

      let ps = [];

      for (let i = 0; i < ids.length; ++i) {
        if (ids[i] > 0) {
          let p = this.teMouldBomApi.info(ids[i]);
          ps.push(p)
        }

      }

      ps = this.modelData.filter(item => {
        return item.TemouldBomId > 0;
      })
      console.log("ps", ps);

      if (ps.length !== 0) {

        let arr = [];
        ps.forEach(res => {

          let o = {
            name: res.MouldName,
            DetailModels: res.DetailDtos,
          }
          arr.push(o)

        })

        this.detailData = arr;
        console.log("this.detailData", this.detailData);

      }
    },
    setSubTableData(list) {
      this.subTableData = list;
    },
    setCraftData(data) {
      let arr = [];

      if (data.length !== 0) {
        data.forEach((item) => {
          item.ProcessModels.forEach((v) => {
            v.T = 1;
          });
        });

        data.forEach((item) => {
          let o = {
            MouldName: item.MouldName,
            MouldNo: item.MouldNo,
            ProgrammeId: item.ProcessModels[0].ProgrammeId,
            ProgrammeName: item.ProcessModels[0].ProgrammeName,
            Processes: item.ProcessModels,
          };
          arr.push(o);
        });

        this.craftData = arr;
      } else {
        this.craftData = [];
      }
    },
    onSelect(e, row) {
      if (row.T !== 0) {
        row.T = 1;
      }
      console.log("wjGlue  e========", e);
      row.ColorId = null;
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductSpec = e.ProductSpec;
      row.ProcessStage = e.ProcessStage;
      row.ProduceTypeName = e.ProduceTypeName;
      row.ProductId = e.ProductId;
      row.Mould = e.Mould;
      row.MouldId = e.MouldId;
      row.MouldName = e.MouldName;
      row.Colors = e.Colors;
      row.PdUnitName = e.PdUnitName;
      row.PdUnitId = e.PdUnitId;
      row.UseColor = e.UseColor;
      row.Property = null;
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage(val) {
      this.pageParams.pageIndex = val;
      this.pdApi.list({ status: 1 }).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;
          this.listTotal = res.Count;
        }
      });
    },
    inputText(text) {
      this.pdApi
        .list({ ProductName: text })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    add(list) {
      list.child.push({
        T: 0,
        ColorId: null,
        ColorName: "",
        UnitId: "",
        Quantity: 0,
        Remarks: "",

        AddTime: "",
        AddUserId: "",
        AddUserName: "",
        BaseUnitId: "",
        BatchNumber: "",
        ClassId: "",
        ClassName: "",
        Colors: "",
        DefaultSupplier: "",
        DefaultWarehouse: "",
        ExpireDay: "",
        GoldenTaxCode: "",
        GrossWeight: "",
        HasExpire: "",
        IdChain: "",
        ImgUrl: "",
        LeadTime: "",
        MaxStock: "",
        MinStock: "",
        Mould: "",
        MouldId: "",
        MouldName: "",
        MouldRubberId: "",
        NetWeight: "",
        PdUnitId: "",
        PdUnitName: "",
        ProcessStage: "",
        ProduceTypeName: "",
        ProductId: "",
        ProductName: "",
        ProductNo: "",
        ProductSpec: "",
        ProductStatusId: "",
        ProductType: "",
        Property: "",
        PuUnitId: "",
        PuUnitName: "",
        Rate: "",
        RpUnitId: "",
        RpUnitName: "",
        SaUnitId: "",
        SaUnitName: "",
        SafetyStock: "",
        ShortName: "",
        SkUnitId: "",
        SkUnitName: "",
        Sn: "",
        Status: "",
        StatusName: "",
        TradeUnitFullName: "",
        TradeUnitShortName: "",
        UnitGroupId: "",
        UnitType: "",
        Units: "",
        UpdateTime: "",
        UpdateUserId: "",
        UpdateUserName: "",
        UseColor: "",
        UseProcess: "",
        ValuationId: "",
        ValuationName: "",
        Volume: "",
        WarehouseName: "",
        WarehouseNo: "",
      });
    },
    select(item, index) {
      let Pname = this.tableData[index].ProductName;
      this.tempItem = item;
      this.$refs.bomDialog.open().then((that) => {
        that.getList(0, Pname);
      });
    },
    del(row, index, list) {
      this.$confirm("确定删除这些记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (row.T !== 0) {
          row.T = 2;
        }
        this.delTable.push(row);
        list.child.splice(index, 1);
        console.log("delTable", this.delTable);
      });
    },
    saved(list, item) {
      item.child = [];
      this.$nextTick(() => {
        item.child.push(...list);
      })
    },
    base64ToFile(dataurl, filename) {//将base64转换为文件
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg);
      const ImgUrl = res.Data;
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！');
      let imgs = [];
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl));
        // imgs.push(imgBlob);
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs;
      this.$refs.imgDialog.open();
    },
    // viewImg(ImgUrl) {
    //   let imgs = ImgUrl.split(",");
    //   imgs.forEach((item) => {
    //     item = urlHttp + item;
    //   });

    //   this.imgs = imgs;
    //   this.$refs.imgDialog.open();
    // },
    processChange(row) {
      let id = row.ProcessId;
      let ids = this.processList.map((item) => {
        return item.ProcessId;
      });
      let index = ids.indexOf(id);
      row.Sn = this.processList[index].Sn;
    },
    changeColor(val, row) {
      let ids = row.Colors.map((item) => {
        return item.ColorId;
      });
      let index = ids.indexOf(val);
      let color = row.Colors[index];

      row.ColorId = color.ColorId;
      row.ColorName = color.ColorName;
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    changeQuantity(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },

    getProcess(Processes, mode) {
      let arr = [];
      Processes.forEach((item) => {
        let {
          T,
          DpId,
          ProcessId,
          ProcessName,
          ProcessNo,
          ProcessType,
          ProgrammeId,
          ProcessSn,
          ProgrammeName,
          Stage,
          TeProductProcessId = 0,
          TebomId = 0,
          BomType = 0,
        } = item;
        BomType = 0;

        let o = {};

        if (mode === 0) {
          o = {
            T,
            DpId,
            ProcessId,
            ProcessName,
            ProcessNo,
            ProcessType,
            ProgrammeId,
            ProcessSn,
            ProgrammeName,
            Stage,
            TeProductProcessId,
            TebomId,
            BomType,
          };
        } else {
          o = {
            DpId,
            ProcessId,
            ProcessName,
            ProcessNo,
            ProcessType,
            ProgrammeId,
            ProcessSn,
            ProgrammeName,
            Stage,
            TeProductProcessId,
            TebomId,
            BomType,
          };
        }

        arr.push(o);
      });

      return arr;
    },
    getProgramme(mode) {
      let arr = [];
      this.craftData.forEach((item) => {
        let ProcessModels = this.getProcess(item.Processes, mode);
        let o = {
          ProcessModels,
          ProgrammeId: item.ProgrammeId ? item.ProgrammeId : 0,
        };
        arr.push(o);
      });

      return arr;
    },
    getDetailModels(index, mode = 0, _TebomId) {
      let child = this.subTableData[index].child;

      let DetailModels = [];
      child.forEach((item) => {
        console.log("item", item);
        if (mode === 0) {
          if (item.T != null) {
            let {
              T,
              ProductId,
              ColorId = 0,
              Quantity,
              ProductNo,
              Property = 0,
              ProductName,
              ProcessStage,
              ProductSpec,
              Remarks = "",
              ColorName,
              TeProductDetailId = 0,
              TebomId = 0,
              BomType = 0,
            } = item;
            BomType = 0;
            Quantity = Number(Quantity);
            if (Property == null) {
              Property = 0;
            }
            ColorId = ColorId ?? 0;

            let o = {
              T,
              ProductId,
              ColorId,
              Quantity,
              ProductNo,
              ProductName,
              Property,
              ProcessStage,
              ProductSpec,
              ColorName,
              TeProductDetailId,
              Remarks,
              TebomId,
              BomType,
            };

            DetailModels.push(o);
          }
        } else {
          let {
            ProductId,
            ColorId = 0,
            Quantity,
            ProductNo,
            Property = 0,
            ProductName,
            ProcessStage,
            TeProductId = 0,
            ProductSpec,
            Remarks = "",
            ColorName,
            TeProductDetailId = 0,
            TebomId = 0,
            BomType = 0,
          } = item;
          BomType = 0;
          Quantity = Number(Quantity);
          if (Property == null) {
            Property = 0;
          }
          ColorId = ColorId ?? 0;

          let o = {
            ProductId,
            ColorId,
            Quantity,
            ProductNo,
            ProductName,
            TeProductId,
            Property,
            ProcessStage,
            ProductSpec,
            ColorName,
            TeProductDetailId,
            Remarks,
            TebomId,
            BomType,
          };

          DetailModels.push(o);
        }
      });

      if (mode === 0) {
        this.delTable.forEach((item) => {
          if (_TebomId === item._TebomId) {
            let {
              T,
              ProductId,
              ColorId = 0,
              Quantity,
              ProductNo,
              Property = 0,
              ProductName,
              BomType = 4,
              ProcessStage,
              Remarks = "",
              ProductSpec,
              ColorName,
              TeProductDetailId = 0,
              TebomId = 0,
            } = item;
            BomType = 4;
            Quantity = Number(Quantity);
            if (Property == null) {
              Property = 0;
            }
            ColorId = ColorId ?? 0;

            let o = {
              T,
              ProductId,
              ColorId,
              Quantity,
              ProductNo,
              ProductName,
              Property,
              ProcessStage,
              Remarks,
              BomType,
              ProductSpec,
              ColorName,
              TeProductDetailId,
              TebomId,
            };

            DetailModels.push(o);
          }

        });
      }

      return DetailModels;
    },
    getSaveData(mode = 0 && mode === 0) {
      let BomModels = [];
      let bool = true;
      this.tableData.forEach((item, index) => {
        let {
          Bomno,
          Quantity,
          TebomId = 0,
          BomType = 0,
          MouldId,
          MouldName,
          Remarks,
          MouldNo,
        } = item;
        Quantity = Number(Quantity);
        BomType = 0;
        if (Bomno == null || Bomno == "") {
          this.$message({ type: "warning", message: "请填写注胶BOM版本" });
          bool = false;
        }

        let DetailModels = this.getDetailModels(index, mode, TebomId);
        if (mode === 1 && DetailModels.length === 0) {
          bool = false;
        }

        let Programme = this.getProgramme(mode);

        if (mode === 1) {
          Programme.forEach((item) => {
            if (item.ProgrammeId == 0) {
              bool = false;
            }
          });
        }

        let o = {
          DetailModels,
          Bomno,
          Quantity,
          TebomId,
          BomType,
          ProgrammeId: Programme[index] ? Programme[index].ProgrammeId : 0,
          ProcessModels: Programme[index] ? Programme[index].ProcessModels : [],
          Remarks,
          MouldId,
          MouldName,
          MouldNo,
        };
        BomModels.push(o);
      });

      console.log("注胶 BomModels", BomModels);

      if (bool) {
        return BomModels;
      } else {
        return [];
      }
    },
    copyDetailModels(index) {
      let child = this.subTableData[index].child;

      let DetailModels = [];
      child.forEach((item) => {
        console.log("item", item);
        let {
          T,
          ProductId,
          ColorId = 0,
          Quantity,
          ProductNo,
          Property = 0,
          ProductName,
          ProcessStage,
          ProductSpec,
          Remarks = "",
          ColorName,
          TeProductDetailId = 0,
          TebomId = 0,
          BomType = 0,
        } = item;
        BomType = 0;
        Quantity = Number(Quantity);
        if (Property == null) {
          Property = 0;
        }
        ColorId = ColorId ?? 0;

        let o = {
          T,
          ProductId,
          ColorId,
          Quantity,
          ProductNo,
          ProductName,
          Property,
          ProcessStage,
          ProductSpec,
          ColorName,
          TeProductDetailId,
          Remarks,
          TebomId,
          BomType,
        };

        DetailModels.push(o);
      });



      return DetailModels;
    },
    copyData(mode = 0) {
      let BomModels = [];
      let bool = true;
      this.tableData.forEach((item, index) => {
        let {
          Bomno,
          Quantity,
          TebomId = 0,
          BomType = 0,
          MouldId,
          MouldName,
          Remarks,
          MouldNo,
        } = item;
        Quantity = Number(Quantity);
        BomType = 0;
        if (Bomno == null || Bomno == "") {
          this.$message({ type: "warning", message: "请填写注胶BOM版本" });
          bool = false;
        }

        let DetailModels = this.copyDetailModels(index);
        if (mode === 1 && DetailModels.length === 0) {
          bool = false;
        }

        let Programme = this.getProgramme(mode);

        if (mode === 1) {
          Programme.forEach((item) => {
            if (item.ProgrammeId == 0) {
              bool = false;
            }
          });
        }

        let o = {
          DetailModels,
          Bomno,
          Quantity,
          TebomId,
          BomType,
          ProgrammeId: Programme[index] ? Programme[index].ProgrammeId : 0,
          ProcessModels: Programme[index] ? Programme[index].ProcessModels : [],
          Remarks,
          MouldId,
          MouldName,
          MouldNo,
        };
        BomModels.push(o);
      });

      console.log("注胶 BomModels", BomModels);

      if (bool) {
        return BomModels;
      } else {
        return [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
</style>
